import { useConfirmationDialog } from '@openx/components-core/lib/Dialog/ConfirmationDialog/useConfirmationDialog';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CTVModalContent } from '../CTVModalContent';

type CTVModalParams = {
  onConfirmed: () => void;
  onCancel: () => void;
};

export const useCTVModal = () => {
  const { t } = useTranslation();
  const confirmationDialog = useConfirmationDialog();

  const showCTVModal = useCallback(
    ({ onConfirmed, onCancel }: CTVModalParams) => {
      confirmationDialog.open({
        confirmationButtonColor: 'primary',
        confirmationLabel: t('Yes, change Format to CTV'),
        content: <CTVModalContent />,
        customContent: true,
        onCancel: () => {
          onCancel();
          confirmationDialog.close();
        },
        onConfirmed: () => {
          onConfirmed();
          confirmationDialog.close();
        },
        title: t('Warning'),
      });
    },
    [confirmationDialog.close, confirmationDialog.open, t]
  );

  return { showCTVModal };
};
